import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../routes/paths';
import { useWishlist } from '../hooks/useWishlist';
import { HeartIcon } from './HeartButton';

/** Showroom app bar: light ground, ink brand text, HP blue accent. */
export function AppBar({ title }: { title?: string }): JSX.Element {
  const navigate = useNavigate();
  // Reads the already-streamed user doc, so the count costs nothing.
  const { count } = useWishlist();
  return (
    <header className="flex items-center justify-between border-b border-slate-100 bg-ground px-4 py-3">
      <button
        type="button"
        onClick={() => navigate(ROUTES.home)}
        className="flex items-center gap-2 text-[17px] font-extrabold tracking-tight text-ink"
      >
        <img src="/logo-mark.png" alt="" className="h-7 w-7" />
        {title ?? (
          <>
            <span className="text-brand">HP</span> @ ANYWAY IT SOLUTIONS
          </>
        )}
      </button>
      <div className="flex shrink-0 items-center gap-1.5">
        <button
          type="button"
          aria-label={`Saved products${count > 0 ? ` (${count})` : ''}`}
          onClick={() => navigate(ROUTES.saved)}
          className={`flex items-center gap-1 rounded-full px-3 py-1.5 text-xs font-bold ${
            count > 0 ? 'bg-hot/10 text-hot' : 'bg-chipbg text-slate-500'
          }`}
        >
          <HeartIcon filled={count > 0} size={14} />
          {count > 0 ? count : null}
        </button>
        <button
          type="button"
          aria-label="Profile"
          onClick={() => navigate(ROUTES.profile)}
          className="rounded-full bg-chipbg px-3.5 py-1.5 text-xs font-semibold text-slate-600"
        >
          Profile
        </button>
      </div>
    </header>
  );
}
